;(function($){

    function Contracts() {
        var _                     = this;
        _.total_hours             = 0;
        _.value_hour              = 0.00;
        _.contracts_value         = 0.00;
        _.total_hours_analyst     = 0;
        _.value_hour_analyst      = 0.00;
        _.contracts_value_analyst = 0.00;
        _.profitability           = 0.00;

        $("#total_hours").on("change", function(e){
            e.preventDefault();
            _.calcTotal();
        });

        $("#value_hour").on("change", function(e){
            e.preventDefault();
            _.calcTotal();
        });

        $("#total_hours_analyst").on("change", function(e){
            e.preventDefault();
            _.calcTotal();
        });

        $("#value_hour_analyst").on("change", function(e){
            e.preventDefault();
            _.calcTotal();
        });

        $("#users_id").on("change", function(e){
            _.getAnalyst($(this).val());
        });

        $("#contracts_id").on("change", function(e){
            e.preventDefault();
            if($(this).val() != ""){ 
                _.getMeta($(this).val());
            }
        });
		

        $("#start_date").on("focusout", function(e){
            e.preventDefault();

            if(($(this).val() > $("#ending_date").val()) && $("#ending_date").val() != "") {
                swal({
                    title: "OPS",
                    text: "A data de inicio é maior que a data final, corrija a informação!",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Fechar!",
                    closeOnConfirm: false
                }); 
            }
        });

        $("#ending_date").on("focusout", function(e){
            e.preventDefault();

            if(($(this).val() < $("#start_date").val()) && $("#start_date").val() != "") {
                swal({
                    title: "OPS",
                    text: "A data final é menor que a data inicial, corrija a informação!",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Fechar!",
                    closeOnConfirm: false
                }); 
            }
        });

        _.calcTotal();
    }

    Contracts.prototype.getAnalyst =  function(users_id){
        var _ = this;

        $.get($("#app_url").val() + "/api/usuarios/"+ users_id, function( data ) {
            $("#value_hour_analyst").val(data.value_hour);
        }).done(function(e){
            $(document).find("#value_hour_analyst").trigger('input');
        });
    };

    Contracts.prototype.getMeta =  function(contracts_id){
        var _ = this;

        $.get($("#app_url").val() + "/api/contrato/"+ contracts_id, function( total_hours ) { 
            if(total_hours != ""){
                $("#total_hours").val(total_hours);
            }else{
            $("#total_hours").val(0);
            }
        });
    };

    Contracts.prototype.calcTotal =  function() {
        var _                     =  this;        
        _.total_hours             = $(document).find("#total_hours").val();
        _.value_hour              = $(document).find("#value_hour").val();
        _.contracts_value         = $(document).find("#contracts_value").val();
        _.total_hours_analyst     = $(document).find("#total_hours_analyst").val();
        _.value_hour_analyst      = $(document).find("#value_hour_analyst").val();
        _.contracts_value_analyst = $(document).find("#contracts_value_analyst").val();
        _.profitability           = $(document).find("#profitability").val();

        _.total_hours             = (!_.total_hours) ? 0 : _.total_hours;
        _.value_hour              = (!_.value_hour) ? 0.00 : _.value_hour;
        _.contracts_value         = (! _.contracts_value) ? 0.00 :  _.contracts_value;
        _.total_hours_analyst     = (!_.total_hours_analyst) ? 0 : _.total_hours_analyst;
        _.value_hour_analyst      = (!_.value_hour_analyst) ? 0.00 : _.value_hour_analyst;
        _.contracts_value_analyst = (!_.contracts_value_analyst) ? 0.00 : _.contracts_value_analyst;
        _.profitability           = (!_.profitability) ? 0.00 : _.profitability;

        _.value_hour              = _.value_hour.toString();
        _.contracts_value         = _.contracts_value.toString();
        _.value_hour_analyst      = _.value_hour_analyst.toString();
        _.contracts_value_analyst = _.contracts_value_analyst.toString();
        _.profitability           = _.profitability.toString();

        _.value_hour              = _.value_hour.replace('.','');
        _.contracts_value         = _.contracts_value.replace('.','');
        _.value_hour_analyst      = _.value_hour_analyst.replace('.','');
        _.contracts_value_analyst = _.contracts_value_analyst.replace('.','');
        _.profitability           = _.profitability.replace('.','');

        _.value_hour              = _.value_hour.replace(',','.');
        _.contracts_value         = _.contracts_value.replace(',','.');
        _.value_hour_analyst      = _.value_hour_analyst.replace(',','.');
        _.contracts_value_analyst = _.contracts_value_analyst.replace(',','.');
        _.profitability           = _.profitability.replace(',','.');

        _.value_hour              = parseFloat(_.value_hour);
        _.contracts_value         = parseFloat(_.contracts_value);
        _.value_hour_analyst      = parseFloat(_.value_hour_analyst);
        _.contracts_value_analyst = parseFloat(_.contracts_value_analyst);
        _.profitability           = parseFloat(_.profitability);

        _.value_hour              = _.value_hour.toFixed(2);
        _.contracts_value         = _.contracts_value.toFixed(2);
        _.value_hour_analyst      = _.value_hour_analyst.toFixed(2);
        _.contracts_value_analyst = _.contracts_value_analyst.toFixed(2);
        _.profitability           = _.profitability.toFixed(2);

        _.contracts_value         = (_.total_hours *  _.value_hour);
        _.contracts_value_analyst = (_.total_hours_analyst * _.value_hour_analyst);
        _.profitability           = (_.contracts_value - _.contracts_value_analyst);

        _.value_hour              = parseFloat(_.value_hour);
        _.contracts_value         = parseFloat(_.contracts_value);
        _.value_hour_analyst      = parseFloat(_.value_hour_analyst);
        _.contracts_value_analyst = parseFloat(_.contracts_value_analyst);
        _.profitability           = parseFloat(_.profitability);

        _.value_hour              = _.value_hour.toFixed(2);
        _.contracts_value         = _.contracts_value.toFixed(2);
        _.value_hour_analyst      = _.value_hour_analyst.toFixed(2);
        _.contracts_value_analyst = _.contracts_value_analyst.toFixed(2);
        _.profitability           = _.profitability.toFixed(2);

        _.value_hour              = _.value_hour.toString();
        _.contracts_value         = _.contracts_value.toString();
        _.value_hour_analyst      = _.value_hour_analyst.toString();
        _.contracts_value_analyst = _.contracts_value_analyst.toString();
        _.profitability           = _.profitability.toString();

        _.value_hour              = _.value_hour.replace('.',',');
        _.contracts_value         = _.contracts_value.replace('.',',');
        _.value_hour_analyst      = _.value_hour_analyst.replace('.',',');
        _.contracts_value_analyst = _.contracts_value_analyst.replace('.',',');
        _.profitability           = _.profitability.replace('.',',');

        //Set Values
        $(document).find("#total_hours").val(_.total_hours);

        $(document).find("#value_hour").val(_.value_hour);

        $(document).find("#contracts_value").val(_.contracts_value);
        $(document).find("#contracts_value_disabled").val(_.contracts_value).attr('value', _.contracts_value);

        $(document).find("#total_hours_analyst").val(_.total_hours_analyst);
        $(document).find("#value_hour_analyst").val(_.value_hour_analyst);

        $(document).find("#contracts_value_analyst").val(_.contracts_value_analyst);
        $(document).find("#contracts_value_analyst_disabled").val(_.contracts_value_analyst).attr('value', _.contracts_value_analyst);

        $(document).find("#profitability").val(_.profitability); 
        $(document).find("#profitability_disabled").val(_.profitability).attr('value', _.profitability);

        $(document).find("#value_hour").trigger('input');
        $(document).find("#contracts_value").trigger('input');
        $(document).find("#contracts_value_disabled").trigger('input');
        $(document).find("#value_hour_analyst").trigger('input');
        $(document).find("#contracts_value_analyst").trigger('input');
        $(document).find("#contracts_value_analyst_disabled").trigger('input');
        $(document).find("#profitability").trigger('input'); 
        $(document).find("#profitability_disabled").trigger('input'); 
    
    };

   	new Contracts();

}(jQuery));